import { configureStore } from "@reduxjs/toolkit";
import AppReducer from "../reducers/AppReducer";

export const store = configureStore({
    reducer: {
        aplicacion: AppReducer
    },
    devTools: process.env.REACT_APP_HABILITA_DEV_TOOL === 'true',
})